import styled, { css, keyframes } from 'styled-components';
import { customMedia } from 'styles/utils';
import Heading from 'components/Heading';
import Button from 'components/Button';

export const welcomeBreakingpoints = {
  desktop: 88,
  mobile: 100,
};

export const workSectionHeightBreaks = {
  desktop: 100,
  mobile: 60,
};

export const MobileTextBackground = styled.div`
  ${props =>
    props.background &&
    css`
      ${customMedia.lessThan('small')`
        h2 {
          background-color: rgb(15, 46, 255, 0.7);
        }
        h6 {
          background-color: rgb(15, 46, 255, 0.7);
        }
        p {
          background-color: rgb(15, 46, 255, 0.7);
        }
      `};
    `}
`;

export const MaxWidthWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  text-align: center;
  position: relative;
  height: 100%;
  width: 100%;
  max-width: ${props => props.theme.layout.maxWidth};

  ${customMedia.greaterThan('xlarge')`
    max-width: ${props => props.theme.layout.maxWidth};
  `}
`;

export const WelcomeMain = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  position: relative;
  min-height: ${welcomeBreakingpoints.desktop}vh;

  ${customMedia.lessThan('medium')`
    min-height: ${welcomeBreakingpoints.mobile}vh;
  `};
`;

export const WelcomeTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  text-align: center;
  padding: ${props => props.theme.spacing.xlarge}
    ${props => props.theme.spacing.large};
  z-index: 3;

  ${customMedia.greaterThan('xlarge')`
    padding: 6rem ${props => props.theme.spacing.large};
  `}

  ${customMedia.lessThan('small')`
    padding: ${props => props.theme.spacing.large} ${props =>
    props.theme.spacing.medium};
    > h1 {
      font-size: ${props => props.theme.font.size.xlarge};
    }
    > h1:last-of-type {
      margin-top: ${props => props.theme.spacing.small};
    }
  `};
`;

export const WelcomeBackgroundLayerStyled = styled.div`
  position: absolute;
  z-index: 2;
  width: 100%;
  height: auto;
  min-height: ${welcomeBreakingpoints.desktop}vh;
  padding: ${props => props.theme.spacing.small};
  background-color: ${props => props.theme.color.wfWhite};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;

  ${customMedia.lessThan('medium')`
    height: ${welcomeBreakingpoints.mobile}vh;
  `};
`;

export const WelcomeBackgroundLayerBlockStyled = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  align-items: flex-start;
  padding: ${props => `0 ${props.theme.spacing.xlarge}`};
  background-color: ${props => props.theme.color.wfWhite};
  max-width: ${props => props.theme.layout.maxWidth};

  ${customMedia.between('medium', 'large')`
    transform: translateX(80px);
    img {
      margin: 0px -80px;
    }
  `};

  ${customMedia.lessThan('medium')`
    justify-content: center;
    margin: ${props => props.theme.spacing.small};
    padding: ${props => props.theme.spacing.small};
    padding-top: 30vh;
    transform: scale(0.8);

    img {
      margin: ${props => `-${props.theme.spacing.xxlarge}`};
    }
  `};

  ${customMedia.lessThan('small')`
    padding-top: 60vh;
    transform: scale(0.55);

    img {
      margin: -80px;
    }
  `};
`;

export const MainWrapper = styled.div`
  min-height: 100vh;
  overflow-y: hidden;
  scroll-snap-type: y mandatory;
`;

export const FullScreenSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  text-align: center;
  width: 100vw;
  max-width: 100vw;
  height: 100vh;
  position: relative;
  scroll-snap-align: start;
  background-color: ${props =>
    props.theme.color[props.color]
      ? props.theme.color[props.color]
      : 'transparent'};

  ${customMedia.lessThan('medium')`
    height: ${props => props.sectionHeight || '100vh'};
  `};
`;

export const WorkspaceSection = styled(FullScreenSection)`
  background-color: ${props => props.theme.color.wfBlue};
`;

export const MainFullScreenSection = styled(FullScreenSection)`
  height: auto;
`;

export const JoinFullScreenSection = styled(FullScreenSection)`
  ${customMedia.lessThan('medium')`
    height: 60vh;
  `};
`;

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const MainBackgroundLayerStyled = styled.div`
  position: fixed;
  z-index: -3;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  will-change: opacity;
  animation-name: ${fadeIn};
  animation-duration: 1.5s;
  animation-timing-function: ease-out;
  animation-delay: 0s;
`;

// To test later
// transform: ${props =>
//   props.ratio ? `translateY(-${props.ratio * 100}%);` : '0'};

export const TextBlockCenter = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  padding: 30%;

  ${customMedia.lessThan('small')`
    padding: 8%;
  `};
`;

const showUp = keyframes`
  0% {
    opacity: 0;
    transform: translateY(150%);
  }
  100% {
    opacity: 1;
    transform: translateY(0%);
  }
`;

export const TextBlockHeading = styled(Heading)`
  margin-bottom: ${props => props.theme.spacing.default};
`;

export const TextBlockButton = styled(Button)`
  border: 1px solid #fff;
  margin-top: ${props => props.theme.spacing.large};
  &:hover {
    border: 1px solid #fff;
    background-color: ${props => props.theme.color.wfBlue900};
  }
`;

export const MovingUp = styled(TextBlockCenter)`
  will-change: transform;
  animation-name: ${showUp};
  animation-duration: 1.2s;
  animation-timing-function: ease-out;
  animation-delay: 0s;
  text-align: left;
`;

const showRightToLeft = keyframes`
  0% {
    transform: translateX(110%);
  }
  100% {
    transform: translateY(0%);
  }
`;

export const MovingRightToLeft = styled(TextBlockCenter)`
  will-change: transform;
  animation-name: ${showRightToLeft};
  animation-duration: 1s;
  animation-timing-function: ease-out;
  animation-delay: 0s;
`;

export const TitleSectionStyled = styled.div`
  display: flex;
  position: absolute;
  left: 0;
  top: ${props => (props.hasBanner ? '130px' : '100px')};
  text-align: left;
  padding: ${props => props.theme.spacing.large} 4vw;
  ${customMedia.lessThan('small')`
    top: ${props => (props.hasBanner ? '90px' : '60px')};
  `};
`;

export const TrendingTitleSectionStyled = styled(TitleSectionStyled)`
  top: 0;
  flex-direction: column;
`;

export const JoinTitleSectionStyled = styled(TrendingTitleSectionStyled)`
  ${customMedia.lessThan('medium')`
    position: static;
  `};
`;

export const TrendingActionSectionStyled = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  padding: ${props => props.theme.spacing.large};

  ${customMedia.lessThan('small')`
    top: 100px;
    left: 0;
  `};
`;

export const TrendingFooterStyled = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  padding: ${props => props.theme.spacing.large};
`;

export const TrendingFooterBlockStyled = styled.div`
  display: flex;
  max-width: 66%;
  border-top: 1px dashed ${props => props.theme.color.wfGrey800};
  padding: ${props => props.theme.spacing.large};

  ${customMedia.lessThan('small')`
    max-width: 66%;
    transform: translateX(0%);
    padding: ${props => props.theme.spacing.small};
  `};
`;

export const TrendingMainBlockStyled = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
`;

export const TrendingViewStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: flex-start;
  overflow-x: hidden;
  width: 100%;
`;

export const TrendingViewContentStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: flex-start;
  will-change: transform;
  transition: transform 2s;
  max-width: 100vw;
  transform: ${props =>
    props.page
      ? `translateX(${-(props.page * 100) + 58}%)`
      : 'translateX(58%)'};
`;

export const NumberSectionStyled = styled.div`
  display: flex;
  position: absolute;
  left: 0;
  bottom: 0;
  padding: ${props => props.theme.spacing.large};

  ${customMedia.lessThan('small')`
    > img {
      transform: scale(0.5) translateX(-190px);
    }
  `};
`;

export const CommunityNumberSectionStyled = styled(NumberSectionStyled)`
  ${customMedia.lessThan('small')`
    > img {
      transform: scale(0.5) translateX(-230px);
    }
  `};
`;

export const ActionSectionStyled = styled.div`
  display: flex;
  position: absolute;
  right: 0;
  bottom: 0;
  padding: ${props => props.theme.spacing.large};
  z-index: 10;
`;

export const ImageBlockStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  padding: 20%;

  img {
    width: 55vw;
    max-width: ${props => props.theme.layout.maxWidth};
    border-radius: ${props => props.theme.image.borderRadius};
    box-shadow: ${props => props.theme.image.boxShadow};
  }

  ${customMedia.lessThan('small')`
    padding: 0;
    img {
      width: 100%;
    }
  `};
`;

export const FooterImageBlockStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin: ${props => `${props.theme.spacing.medium} 0`};

  ${customMedia.lessThan('large')`
    flex-direction: column;
  `};
`;

export const FooterColumnImageBlockStyled = styled(MobileTextBackground)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
  min-width: 20%;
  margin-right: ${props => props.theme.spacing.xxlarge};
  margin-bottom: ${props => props.theme.spacing.medium};

  > p {
    margin-top: 0.75rem;
  }

  ${customMedia.lessThan('small')`
    min-width: 33%;
    margin-right: ${props => props.theme.spacing.small};
    margin-bottom: ${props => props.theme.spacing.small};
  `};
`;

export const JoinImageStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-content: flex-end;
  align-items: flex-end;
  width: 100%;
  height: 100%;
  padding-right: ${props => props.theme.spacing.xxlarge};
  img {
    max-width: 110%;
    max-height: 100%;
  }

  ${customMedia.lessThan('medium')`
    display: none;
  `};
`;

export const JoinContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: flex-start;
  max-width: 26em;
  height: 90vh;
  text-align: left;

  ${customMedia.lessThan('medium')`
    max-width: 80vw;
  `};
`;

export const ParallaxSection = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: space between;
  align-content: center;
  align-items: center;
  height: 100vh;
  perspective: 2px;
  perspective-origin: 0%;
  padding: ${props => props.theme.spacing.xxlarge};
`;

export const ParallaxLayer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

export const ParallaxFront = styled(ParallaxLayer)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  transform: translateZ(0);
  margin-top: 100vh;
  min-height: 100vh;
`;

export const ParallaxBack = styled(ParallaxLayer)`
  transform: translateZ(-1px) scale(1.5);
`;

export const HashTagStyled = styled.div`
  margin-right: ${props => props.theme.spacing.large};
`;

export const ParallaxItemSectionStyled = styled.div`
  width: 100vw;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  padding: ${props => props.theme.spacing.large} 0;
  overflow-x: hidden;
`;

export const ParallaxItemStyled = styled.div`
  padding-top: ${props => props.config.top || '0'};
  padding-right: ${props => props.config.right || '0'};
  padding-bottom: ${props => props.config.bottom || '0'};
  padding-left: ${props => props.config.left || '0'};
  max-width: ${props => props.theme.layout.maxWidth};
  overflow-x: hidden;

  ${customMedia.lessThan('large')`
    padding-top: ${props => props.config.topMobile || props.config.top || '0'};
    padding-right: ${props =>
      props.config.rightMobile || props.config.right || '0'};
    padding-bottom: ${props =>
      props.config.bottomMobile || props.config.bottom || '0'};
    padding-left: ${props =>
      props.config.leftMobile || props.config.left || '0'};
  `};
`;

export const FloatingBlockWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  ${customMedia.lessThan('large')`
    transform: scale(0.7);
  `};

  ${customMedia.lessThan('medium')`
    transform: scale(0.6);
  `};
`;

export const SquareWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: ${props => props.size || 400}px;
  height: ${props => props.size || 400}px;
  padding: 2rem;
  background-color: ${props =>
    props.theme.color[props.color] || props.theme.color.wfGrey500};

  h1 {
    font-size: 110px;
    color: ${props =>
      props.white ? props.theme.color.wfWhite : props.theme.color.wfBlack};
  }

  h4 {
    color: ${props =>
      props.white ? props.theme.color.wfWhite : props.theme.color.wfBlack};
  }
`;

// To remove or move it later =>

export const BottomStickyWrapper = styled.div`
  position: sticky;
  bottom: 0;
  padding: ${props => props.theme.spacing.small} 0;
  background-color: rgba(255, 255, 255, 0.75);
`;

export const CtaButton = styled(Button)`
  margin: ${props => props.theme.spacing.small};
`;
